<script>
	import { twMerge } from 'tailwind-merge';
	let className = '';
	export { className as class };
	import Button from '../ui/Button.svelte';
	import Icon from '$lib/icons/LogoStickerTransparent.svelte';
	import bgAbout from '$lib/assets/sections/bg-about-home@2x.webp';
</script>

<section
	class={twMerge(
		'flex items-center justify-center bg-black bg-opacity-40 px-8 py-32 text-primary-400 md:px-16 ',
		className
	)}
	style="
		background: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)),
					url({bgAbout});
		background-size: cover;
		background-position: center;
	"
>
	<div class="m-auto flex w-full max-w-screen-xl flex-col items-center text-center">
		<Icon class="mb-24 max-w-[200px]" />

		<h2 class="mb-24 max-w-[600px] text-3xl font-bold">
			We empower and inspire people to change their lives by training them how to wrap anything in
			the most professional and efficient way.
		</h2>

		<a href="/about" class="">
			<Button size="lg">About The Wrap Institute</Button>
		</a>
	</div>
</section>
